import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
/* import Axios from "../../../utils/Axios/AxiosProxy"; */
import UserEntryPopup from "../../../components/UserEntryPopup/UserEntryPopup";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function EndScreen({ submitOrder, ...props }) {
  const [accountCreated, setAccountCreated] = React.useState(false);
  const [orderSubmitted, setOrderSubmitted] = React.useState(false);

  useEffect(() => {
    if (!orderSubmitted) {
      submitOrder();
      setOrderSubmitted(true);
    }
  }, [submitOrder, orderSubmitted]);

  /*   const resendEmail = () => {
    const data = JSON.stringify({ email: props.contact.email });
    Axios.post("/api/user/email", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("RESEND EMAIL RESPONSE: ", response.data);
      })
      .catch((error) => {
        console.log("RESEND EMAIL ERROR: ", error.response.data);
      })
      .catch((error) => console.log("RESEND EMAIL CLIENT", error));
  }; */
  return (
    <>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion">{i18n.t("ordersubmitted.label")}</p>
        </div>
        {props.loggedIn ? (
          <></>
        ) : (
          <div className="FormTitleContainer MarginHorizontal">
            <p
              className="FormQuestion"
              style={{ fontSize: "26px", fontStyle: "italic" }}
            >
              {accountCreated
                ? i18n.t("ordersubmitted.registered")
                : i18n.t("ordersubmitted.register")}
            </p>
          </div>
        )}
      </div>
      <div className="NavigationContainer FlexStart FormWidth">
        {props.loggedIn ? (
          <>
            <Link to="/dashboard">
              <Button className="TransparentWhite Medium">
                {i18n.t("ordersubmitted.gotoprofile")}
              </Button>
            </Link>
          </>
        ) : (
          <>
            {accountCreated ? null : (
              <UserEntryPopup
                contact={props.contact}
                register
                setAccountCreated={setAccountCreated}
              />
            )}

            {/* <Button
                onClick={() => resendEmail()}
                className="TransparentWhite Medium"
              >
                Resend email
              </Button> */}
          </>
        )}
      </div>
    </>
  );
}

export default withTranslation()(EndScreen);
